
import { ActionItem } from "../../types/actionItems";
import { AlertCircle, Calendar, CalendarClock, CalendarDays } from "lucide-react";
import { TaskSection } from "./TaskSection";
import React from "react";

interface TaskCategoriesProps {
  categorizedTasks: {
    overdue: ActionItem[];
    today: ActionItem[];
    thisWeek: ActionItem[];
    upcoming: ActionItem[];
  };
  showUpcoming: boolean;
}

export const TaskCategories = ({ categorizedTasks, showUpcoming }: TaskCategoriesProps) => {
  const sections = [
    {
      title: "Overdue Tasks",
      items: categorizedTasks.overdue,
      icon: AlertCircle,
      iconColor: "text-red-600"
    },
    {
      title: "Due Today",
      items: categorizedTasks.today,
      icon: Calendar,
      iconColor: "text-orange-600"
    },
    {
      title: "Due This Week",
      items: categorizedTasks.thisWeek,
      icon: CalendarDays,
      iconColor: "text-blue-600"
    }
  ];

  // Only show upcoming if explicitly allowed and we have upcoming tasks
  const shouldShowUpcomingSection = showUpcoming && categorizedTasks.upcoming.length > 0;

  return (
    <div className="space-y-6">
      {sections.map((section) => (
        <TaskSection
          key={section.title}
          title={section.title}
          items={section.items}
          icon={section.icon}
        />
      ))}
      {shouldShowUpcomingSection && (
        <TaskSection
          title="Upcoming"
          items={categorizedTasks.upcoming}
          icon={CalendarClock}
        />
      )}
    </div>
  );
};